module.exports = __webpack_public_path__ + "static/media/evolution.c3d5ef11.svg";